export default __webpack_public_path__ + "static/media/sala02.e25b8f88.png";